module.exports = __webpack_public_path__ + "static/media/git-commit.9da70021.svg";